import { ICepTypes, ICep } from './types';

export function getCepRequest(cep: string) {
  return {
    type: ICepTypes.GET_CEP_REQUEST,
    payload: { cep },
  };
}
export function getCepSuccess(cep: ICep) {
  return {
    type: ICepTypes.GET_CEP_SUCCESS,
    payload: { cep },
  };
}
export function getCepFailure() {
  return {
    type: ICepTypes.GET_CEP_FAILURE,
  };
}

export function clearCepRequest() {
  return {
    type: ICepTypes.CLEAR_CEP_REQUEST,
  };
}
